import WithDirection from '@app/settings/withDirection';
import { InputNumber } from 'antd';
import AntInputNumber from './styles/inputNumber.style';

const WDInputnumber = AntInputNumber(InputNumber);

export const IsoInputNumber = WithDirection(WDInputnumber);
